<div class="p-4 text-white rounded-lg text-center">
    <img [src]="data.paraCompartilhar" [alt]="data.nome" class="rounded-xl mb-4" />

    <p class="text-xl font-bold mb-4">{{ data.nome }}</p>

    <div class="text-base font-semibold mb-2">
        Compartilhe sua conquista:
    </div>
    <div class="flex flex-row gap-3 justify-center">
        <button mat-icon-button class="w-12 h-12 flex items-center justify-center rounded-full bg-[#E4811E]"
            (click)="compartilhar()" matTooltip="Compartilhe no WhatsApp" [matTooltipClass]="'tooltip-zinc'" aria-label="Compartilhar no WhatsApp">
            <img src="assets/icon/whatsapp.png" alt="" class="w-6 h-6 object-contain pointer-events-none select-none"
                draggable="false" />
        </button>

        <button mat-icon-button matTooltip="Compartilhe no LinkedIn" [matTooltipClass]="'tooltip-zinc'"
            class="w-12 h-12 flex items-center justify-center rounded-full bg-[#E4811E]" (click)="compartilharLinkedin()">
            <mat-icon svgIcon="feather:linkedin" class="text-black"></mat-icon>
        </button>
    </div>
</div>
